/** @format */

import React, { memo } from 'react'
import { NavLink } from 'react-router-dom'

import styles from './row.module.css'

export const Row = memo(({ title, path }) => (
  <NavLink
    style={{ color: '#ffffff' }}
    activeClassName={styles.isActive}
    className={styles.link}
    to={path}
  >
    {title}
  </NavLink>
))
